import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { Url } from '@wix/da-url';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import DaDreamupLogoAndText from '@wix/da-ds/pkg/DaDreamupLogoAndText';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { DeviationLink } from '../../../../Duperbrowse';
import s from './DreamupInfo.scss';
function getHighlightedCallToActionText(t, isMobile, hasCoreMembership) {
    if (hasCoreMembership && isMobile) {
        return t('deviation.details.dreamup.callToAction.link.text.core.mobile');
    } else if (hasCoreMembership && !isMobile) {
        return t('deviation.details.dreamup.callToAction.link.text.core.desktop');
    } else if (isMobile) {
        return t('deviation.details.dreamup.callToAction.link.text.free.mobile');
    } else {
        return t('deviation.details.dreamup.callToAction.link.text.free.desktop');
    }
}
const CallToActionBlock = ()=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const { hasCoreMembership } = useContext(SessionContext);
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: s['call-to-action-block'],
        href: Url.dreamupLink(),
        biData: BiData({
            evid: 923,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue
        })
    }, /*#__PURE__*/ React.createElement(DaDreamupLogoAndText, {
        className: s['logo'],
        view: 'light'
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['call-to-action-text-stack']
    }, !isMobile && /*#__PURE__*/ React.createElement("p", {
        className: s['call-to-action-forward-copy']
    }, t('deviation.details.dreamup.callToAction.forwardCopy')), /*#__PURE__*/ React.createElement("span", {
        className: s['call-to-action-highlighted-text']
    }, getHighlightedCallToActionText(t, isMobile, hasCoreMembership))));
};
CallToActionBlock.displayName = 'CallToActionBlock';
const InfoEntry = ({ left, right, highlightValue })=>/*#__PURE__*/ React.createElement("p", {
        className: s['info-entry']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['info-entry-preface']
    }, left, ":"), /*#__PURE__*/ React.createElement("span", {
        className: c(s['info-entry-value'], highlightValue && s['highlight'])
    }, right));
InfoEntry.displayName = 'InfoEntry';
const DreamupInfo = ({ author, prompt, promptHidden, variationSource, className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: c(s['root'], className)
    }, (prompt || promptHidden) && author && /*#__PURE__*/ React.createElement(InfoEntry, {
        left: t('deviation.details.dreamup.prompt.preface'),
        right: promptHidden ? t('deviation.details.dreamup.prompt.hidden', {
            username: author.username
        }) : prompt
    }), variationSource && /*#__PURE__*/ React.createElement(InfoEntry, {
        left: t('deviation.details.dreamup.variation.preface'),
        right: /*#__PURE__*/ React.createElement(DeviationLink, {
            deviation: variationSource,
            canLinkToStash: true
        }, t('deviation.details.dreamup.variation.text')),
        highlightValue: true
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['call-to-action-and-preface']
    }, // No prompt means this wasn't created with Dreamup, so we drop the "created with" preface
    (prompt || promptHidden) && /*#__PURE__*/ React.createElement("p", {
        className: s['call-to-action-preface']
    }, t('deviation.details.dreamup.callToAction.preface')), /*#__PURE__*/ React.createElement(CallToActionBlock, null)));
};
DreamupInfo.displayName = 'DreamupInfo';
export default DreamupInfo;

//# sourceMappingURL=DreamupInfo.js.map